import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Money from 'components/formatters/money-formatter';
import { inject, observer } from 'mobx-react';
import CollapseIndicator from 'components/indicators/collapse-indicator';
import { withNamespaces } from 'react-i18next';
import SmallCategories from 'modules/budget/components/budget-table/small-categories';

@withNamespaces()
@inject('store')
@observer
class BigCategory extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: true,
        };

        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState(state => ({open: !state.open}));
    }

    render() {
        const { open } = this.state;
        const { t, bigCategory } = this.props;
        const { name, budgeted, actual, remaining, categories } = bigCategory;
        const { isMobile } = this.props.store.app;

        return (
            <Fragment>
                <tr className="category">
                    <td onClick={this.toggle} className="category-name-block text-left" colSpan={isMobile ? 3 : 1}>
                        <CollapseIndicator open={open}/>
                        <span className="category-name">{ t(name) }</span>
                    </td>
                    <td className="hidden-sm hidden-xs text-right">
                        <Money value={budgeted} />
                    </td>
                    <td className="hidden-sm hidden-xs text-right">
                        <Money value={actual} />
                    </td>
                    <td colSpan={isMobile ? 2 : 1} className="text-right">
                        <Money value={remaining} />
                    </td>
                    <td />
                </tr>
                {open && <SmallCategories categories={categories} />}
            </Fragment>
        );
    }
}

BigCategory.propTypes = {
    /** BigCategory from BudgetStore */
    bigCategory: PropTypes.any.isRequired,
};

export default BigCategory;


// WEBPACK FOOTER //
// ./src/modules/budget/components/budget-table/big-category.js